import { formatTime } from "../../../../utils"
export const config = {
    "name": "文章统计",
    "key": "articleStatistics",
    "nav": [
        {
            "name": "单位",
            "tabKey": "0",
            "request": {
                "url": "/cm-sites-mmp/statistics/mediaFusionStaticsCount",
                "method": "get",
                "params": {
                    title: "",
                    startTime: 0,
                    endTime: 0,
                    count: 10,
                    offsite: 1,
                    rmName: "",
                    sortfield: "",
                    sort: 0,
                },
                paramsConfig: {
                    size: "count",
                    page: "offsite",
                    sort: {
                        field: "sortfield",
                        order: {
                            key: "sort",
                            select: {"ascend": '1', "descend": '-1'}
                        },
                    },
                },
                
                resConfig: {
                    count: "count",
                    data: "data"
                },
                "defaultParams": {
                    title: "",
                    startTime: 0,
                    // dataType:"",
                    endTime: 0,
                    count: 10,
                    offsite: 1,
                    rmName: "",
                    sortfield: "viewCount",
                    sortType: 0,
                },

            },
            "renderSearch": {
                "searchConfig": [
                    [
                        {
                            "style": {
                                "float": "left"
                            },
                            "component": {
                                "name": "sta_Input",
                                "config": {
                                    style: {
                                        width: 224
                                    }
                                }
                            },
                            "placeholder": "请输入文章标题",
                            "disabled": false,
                            "id": "sta_name",
                            "size": "default",
                            "labelCode": "title",
                            "labelName": "请输入文章标题",
                            "defaultValue": "",
                            "regStr": "",
                            "regMsg": ""
                        },
 
                        {
                            "style": {
                                "float": "left"
                            },
                            "component": {
                                "name": "sta_Input",
                                "config": {
                                    style: {
                                        width: 224
                                    }
                                }
                            },
                            "placeholder": "请输入融媒体号",
                            "disabled": false,
                            "id": "sta_name",
                            "size": "default",
                            "labelCode": "rmName",
                            "labelName": "请输入融媒体号",
                            "defaultValue": "",
                            "regStr": "",
                            "regMsg": ""
                        },
                        
                        {
                            "style": {
                                "float": "left"
                            },
                            "component": {
                                "name": "sta_Button",
                                "config": {
                                    btnName: "查询",
                                    type: "primary",
                                    clickCall: "onSearch",
                                    style: {
                                        width: 64
                                    }
                                }
                            },
                            "disabled": false,
                            "id": "sta_searchBtn",
                            "size": "default",
                            "labelCode": "",
                        },
                        {
                            "style": {
                                "float": "left"
                            },
                            "component": {
                                "name": "sta_Button",
                                "config": {
                                    btnName: "重置",
                                    type: "default",
                                    clickCall: "onReset",
                                    noRestKey: ["startTime", "endTime"],
                                    style: {
                                        width: 64
                                    }
                                }
                            },
                            "disabled": false,
                            "id": "sta_searchBtn",
                            "size": "default",
                            "labelCode": "",
                        },
                    ],
                    [
                        {
                            "style": {
                                "float": "left"
                            },
                            "component": {
                                "name": "sta_Button",
                                "config": {
                                    btnName: "导出",
                                    type: "default",
                                    clickCall: "onExport",
                                    "request": {
                                        "url": "/cm-sites-mmp/statistics/mediaFusionStaticsCountExport",
                                        "method": "downloadGet",
                                        "params": {
                                            // busName: "busTopicSelection",
                                            pageSize: 9999
                                        },
                                    },
                                    style: {
                                        width: 64
                                    }
                                }
                            },
                            "disabled": false,
                            "id": "sta_searchBtn",
                            "size": "default",
                            "labelCode": "",
                        },
                        {
                            "style": {
                                "float": "right",
                                marginLeft: 'auto'
                            },
                            "component": {
                                "name": "sta_Date",
                                "config": {
                                    selectDateConfig: {
                                        defaultKey: "thisMonth",
                                        selectConfig: ["thisWeek", "lastWeek", "thisMonth", "lastMonth"]
                                    },
                                    onChangeCallFun: "onSearch",
                                    style: {
                                        width: 768
                                    }
                                }
                            },
                            "value:": "this.state.params.name",
                            "placeholder": "自定义日期范围",
                            "disabled": false,
                            "id": "sta_name",
                            "size": "default",
                            'sameDay':true,
                            "labelCode": ["startTime", "endTime"],
                            "defaultValue": [null, null],
                            "labelName": "",
                            "regStr": "",
                            "regMsg": ""
                        },
                    ]
                ]
            },
            "renderTable": {
                "defaultItemWidth": 200,
                "columns": [
                    {
                        "title": '标题',
                        "width": 400,
                        "dataIndex": 'title',
                        "key": 'title',
                        render: '${this.renderOpenModal}',
                        config: {
                            modalComponet: 'articledetailsModal',
                            modalTitle:'文章明细',
                            modalWidth:900,
                            modalFooter:null,
                            modalbodyStyle: {
                                backgroundColor: 'rgba(0, 80, 179, 0.08)',
                                // maxHeight: 550   ,
                            },
                            props: {
                                params: {
                                    startTime: '${state.params.startTime}',
                                    endTime: '${state.params.endTime}',
                                    mediaFusionId: '${record.mediaFusionId}'
                                }
                            },
                            match: {
                                params: {
                                    configName: 'articledetailsModal'
                                }
                            },
                            modalBodyConfig: {
                                "nav": [
                                    {
                                        "name": "单位",
                                        "tabKey": "0",
                                        "request": {
                                            "url": "/cm-sites-mmp/statistics/mediaFusionDetailCount",
                                            "method": "get",
                                            "params": {
                                                count: 10,
                                                offsite: 1,
                                                deptIds: "",
                                                sortfield: "",
                                                sort: 0,
                                                type: 0,
                                            },
                                            "defaultParams": {
                                                count: 10,
                                                offsite: 1,
                                                deptIds: "",
                                                sortfield: "",
                                                sort: 0,
                                                type: 0,
                                            },
                                            "paramsConfig": {
                                                size: "count",
                                                page: "offsite",
                                                sort: {
                                                    field: "sortfield",
                                                    order: {
                                                        key: "sort",
                                                        select: { "ascend": '1', "descend": '-1' }
                                                    },
                                                },
                                            },
                                            "resConfig": {
                                                count: "count",
                                                data: "data"
                                            },
                                        },
                                        "renderSearch": {
                                            "defaultState": {
                                                // 数据层
                                                params: {
                                                    startTime: '${state.params.startTime}',
                                                    endTime: '${state.params.endTime}',
                                                },
                                                // 展现层
                                                input: {
                                                    startTime: '${state.params.startTime}',
                                                    endTime: '${state.params.endTime}',
                                                },
                                                // 页面加载时的原始参数
                                                defaultParams: {
                                                    startTime: '${state.params.startTime}',
                                                    endTime: '${state.params.endTime}',
                                                },
                                            },
                                            "searchConfig": [
                                                [
                                                    {
                                                        "style": {
                                                            "float": "left"
                                                        },
                                                        //时间组件
                                                        "component": {
                                                            "name": "sta_ShowDate",
                                                            "style": {
                                                                "width":250
                                                            }
                                                        },
                                                        "value:": "this.state.params.name",
                                                        "placeholder": "自定义日期范围",
                                                        "disabled": false,
                                                        "id": "sta_name",
                                                        "size": "default",
                                                        "labelCode": ["startTime", "endTime"],
                                                        "defaultValue": [null, null],
                                                        "labelName": "",
                                                        "regStr": "",
                                                        "regMsg": ""
                                                    },
                                                    {
                                                        "style": {
                                                            "float": "left"
                                                        },
                                                        "component": {
                                                            "name": "sta_Cascader",
                                                            "config": {
                                                                style: {
                                                                    width: 224
                                                                },
                                                                searchPlaceholder: '请输入搜索关键词',
                                                                treeId: "0",
                                                                deleteRootNode: true,
                                                                clickCall: "traverseData",
                                                                defaultValue: "thisDept",
                                                                formatConfig: {
                                                                    title: "name",
                                                                    key: "id",
                                                                    value: "id",
                                                                    children: "child",
                                                                },
                                                                "request": {
                                                                    "url": "/cm-sites-sys/dept/getTree?id=0",
                                                                    "method": "get",
                                                                },
                                                                maxTagCount: 1
                                                            }
                                                        },
                                                        "placeholder": "请选择所属部门",
                                                        "disabled": false,
                                                        "id": "sta_dept",
                                                        "size": "default",
                                                        "labelCode": "deptIds",
                                                        "labelName": "请选择所属部门",
                                                        "defaultValue": "0",
                                                        "regStr": "",
                                                        "regMsg": ""
                                                    },
                                                    {
                                                        "style": {
                                                            "float": "left"
                                                        },
                                                        "component": {
                                                            "name": "sta_Button",
                                                            "config": {
                                                                btnName: "查询",
                                                                type: "primary",
                                                                clickCall: "onSearch",
                                                                style: {
                                                                    width: 64
                                                                }
                                                            }
                                                        },
                                                        "disabled": false,
                                                        "id": "sta_searchBtn",
                                                        "size": "default",
                                                        "labelCode": ""
                                                    },
                                                    {
                                                        "style": {
                                                            "float": "left"
                                                        },
                                                        "component": {
                                                            "name": "sta_Button",
                                                            "config": {
                                                                btnName: "重置",
                                                                type: "default",
                                                                clickCall: "onReset",
                                                                noRestKey: ["startTime", "endTime"],
                                                                style: {
                                                                    width: 64
                                                                }
                                                            }
                                                        },
                                                        "disabled": false,
                                                        "id": "sta_searchBtn",
                                                        "size": "default",
                                                        "labelCode": "",
                                                    },
                                                    {
                                                        "style": {
                                                            "float": "left"
                                                        },
                                                        "component": {
                                                            "name": "sta_Button",
                                                            "config": {
                                                                btnName: "导出",
                                                                type: "default",
                                                                clickCall: "onExport",
                                                                "request": {
                                                                    "url": "/cm-sites-mmp/statistics/mediaFusionDetailCountExport",
                                                                    "method": "downloadGet",
                                                                    "params": {
                                                                        busName: "busNewsClue",
                                                                        pageSize: 9999
                                                                    },
                                                                },
                                                                style: {
                                                                    width: 64
                                                                }
                                                            }
                                                        },
                                                        "disabled": false,
                                                        "id": "sta_searchBtn",
                                                        "size": "default",
                                                        "labelCode": "",
                                                    },
                                                ],
                                            ]
                                        },
                                        "renderTable": {
                                            "defaultItemWidth": 200,
                                            "columns": [
                                                {
                                                    "title": '部门名称',
                                                    "width": 100,
                                                    "dataIndex": 'deptName',
                                                    "key": 'deptName',
                                                },
                                                {
                                                    title: '文章阅读总数',
                                                    dataIndex: 'viewCount',
                                                    ellipsis: true,
                                                    sorter: true,
                                                    "width": 100,
                                                },
                                                {
                                                    title: '文章点赞总数',
                                                    dataIndex: 'thumbsupCount',
                                                    ellipsis: true,
                                                    sorter: true,
                                                    "width": 100,
                                                },
                                                {
                                                    title: '文章分享总数',
                                                    dataIndex: 'retransmissionCount',
                                                    ellipsis: true,
                                                    sorter: true,
                                                    "width": 100,
                                                },
                                            ]
                                        },
                                        "renderPage": {
                                            size: "middle",
                                            pageSizeOptions: ['10', '20', '30', '40']
                                        }
                                    },
                                    {
                                        "name": "个人",
                                        "tabKey": "1",
                                        "request": {
                                            "url": "/cm-sites-mmp/statistics/mediaFusionDetailCount",
                                            "method": "get",
                                            "params": {
                                                count: 10,
                                                offsite: 1,
                                                deptIds: "",
                                                sortfield: "",
                                                sort: 0,
                                                type: 1,
                                                phone: "",
                                                userName: "",
                                            },
                                            "defaultParams": {
                                                count: 10,
                                                offsite: 1,
                                                deptIds: "",
                                                sortfield: "",
                                                sort: 0,
                                                type: 1,
                                                phone: "",
                                                userName: "",
                                            },
                                            paramsConfig: {
                                                size: "count",
                                                page: "offsite",
                                                sort: {
                                                    field: "sortfield",
                                                    order: {
                                                        key: "sort",
                                                        select: { "ascend": '1', "descend": '-1' }
                                                    },
                                                },
                                            },
                                            resConfig: {
                                                count: "count",
                                                data: "data"
                                            },
                                        },
                                        "renderSearch": {
                                            "defaultState": {
                                                // 数据层
                                                params: {
                                                    startTime: '${state.params.startTime}',
                                                    endTime: '${state.params.endTime}',
                                                },
                                                // 展现层
                                                input: {
                                                    startTime: '${state.params.startTime}',
                                                    endTime: '${state.params.endTime}',
                                                },
                                                // 页面加载时的原始参数
                                                defaultParams: {
                                                    startTime: '${state.params.startTime}',
                                                    endTime: '${state.params.endTime}',
                                                },
                                            },
                                            "searchConfig": [
                                                [
                                                    {
                                                        "style": {
                                                            "float": "left"
                                                        },
                                                        //时间组件
                                                        "component": {
                                                            "name": "sta_ShowDate",
                                                            "style": {
                                                                "width":250
                                                            }
                                                        },
                                                        "value:": "this.state.params.name",
                                                        "placeholder": "自定义日期范围",
                                                        "disabled": false,
                                                        "id": "sta_name",
                                                        "size": "default",
                                                        "labelCode": ["startTime", "endTime"],
                                                        "defaultValue": [null, null],
                                                        "labelName": "",
                                                        "regStr": "",
                                                        "regMsg": ""
                                                    },
                                                    
                                                    {
                                                        "style": {
                                                            "float": "left"
                                                        },
                                                        "component": {
                                                            "name": "sta_Cascader",
                                                            "config": {
                                                                style: {
                                                                    width: 224
                                                                },
                                                                searchPlaceholder: '请输入搜索关键词',
                                                                treeId: "0",
                                                                deleteRootNode: true,
                                                                clickCall: "traverseData",
                                                                defaultValue: "thisDept",
                                                                formatConfig: {
                                                                    title: "name",
                                                                    key: "id",
                                                                    value: "id",
                                                                    children: "child",
                                                                },
                                                                "request": {
                                                                    "url": "/cm-sites-sys/dept/getTree?id=0",
                                                                    "method": "get",
                                                                },
                                                                maxTagCount: 1
                                                            }
                                                        },
                                                        "placeholder": "请选择所属部门",
                                                        "disabled": false,
                                                        "id": "sta_dept",
                                                        "size": "default",
                                                        "labelCode": "deptIds",
                                                        "labelName": "请选择所属部门",
                                                        "defaultValue": "0",
                                                        "regStr": "",
                                                        "regMsg": ""
                                                    },
                                                    {
                                                        "style": {
                                                            "float": "left"
                                                        },
                                                        "component": {
                                                            "name": "sta_Button",
                                                            "config": {
                                                                btnName: "查询",
                                                                type: "primary",
                                                                clickCall: "onSearch",
                                                                style: {
                                                                    width: 64
                                                                }
                                                            }
                                                        },
                                                        "disabled": false,
                                                        "id": "sta_searchBtn",
                                                        "size": "default",
                                                        "labelCode": "",
                                                    },
                                                    {
                                                        "style": {
                                                            "float": "left"
                                                        },
                                                        "component": {
                                                            "name": "sta_Button",
                                                            "config": {
                                                                btnName: "重置",
                                                                type: "default",
                                                                clickCall: "onReset",
                                                                noRestKey: ["startTime", "endTime"],
                                                                style: {
                                                                    width: 64
                                                                }
                                                            }
                                                        },
                                                        "disabled": false,
                                                        "id": "sta_searchBtn",
                                                        "size": "default",
                                                        "labelCode": "",
                                                    },
                                                    {
                                                        "style": {
                                                            "float": "left"
                                                        },
                                                        "component": {
                                                            "name": "sta_Button",
                                                            "config": {
                                                                btnName: "导出",
                                                                type: "default",
                                                                clickCall: "onExport",
                                                                "request": {
                                                                    "url": "/cm-sites-mmp/statistics/mediaFusionDetailCountExport",
                                                                    "method": "downloadGet",
                                                                    "params": {
                                                                        busName: "busNewsClue",
                                                                        pageSize: 9999
                                                                    },
                                                                },
                                                                style: {
                                                                    width: 64
                                                                }
                                                            }
                                                        },
                                                        "disabled": false,
                                                        "id": "sta_searchBtn",
                                                        "size": "default",
                                                        "labelCode": "",
                                                    },
                                                ],
                                            ]
                                        },
                                        "renderTable": {
                                            // 默认的每列宽度（即最小宽度）
                                            "defaultItemWidth": 100,
                                            "columns": [
                                                {
                                                    "title": '部门名称',
                                                    "width": 100,
                                                    "dataIndex": 'deptName',
                                                    "key": 'deptName',
                                                },
                                                {
                                                    "title": '昵称',
                                                    "width": 100,
                                                    "dataIndex": 'userName',
                                                    "key": 'userName',
                                                },
                                                {
                                                    "title": '手机号',
                                                    "width": 100,
                                                    "dataIndex": 'phone',
                                                    "key": 'phone',
                                                },
                                                {
                                                    title: '文章阅读总数',
                                                    dataIndex: 'viewCount',
                                                    ellipsis: true,
                                                    sorter: true,
                                                    "width": 100,
                                                },
                                                {
                                                    title: '文章点赞总数',
                                                    dataIndex: 'thumbsupCount',
                                                    ellipsis: true,
                                                    sorter: true,
                                                    "width": 100,
                                                },
                                                {
                                                    title: '文章分享总数',
                                                    dataIndex: 'retransmissionCount',
                                                    ellipsis: true,
                                                    sorter: true,
                                                    "width": 100,
                                                },
                                            ]
                                        },
                                        "renderPage": {
                                            size: "middle",
                                            pageSizeOptions: ['10', '20', '30', '40']
                                        }
                                    },
                                ]
                            }
                        }

                    },
                    {
                        "title": '发布时间',
                        "width": 150,
                        "dataIndex": 'publishDate',
                        "key": 'publishDate',
                        render: (record) => {
                            return record?formatTime(record):''
                        }
                    },
                    {
                        "title": '融媒号',
                        "width": 150,
                        "dataIndex": 'rmName',
                        "key": 'rmName',
                    },
                    {
                        title: '阅读数',
                        dataIndex: 'viewCount',
                        ellipsis: true,
                        sorter: true,
                        "width": 100,

                    },
                    {
                        title: '点赞数',
                        dataIndex: 'thumbsupCount',
                        ellipsis: true,
                        sorter: true,
                        "width": 100,
                    },
                    {
                        title: '分享数',
                        dataIndex: 'retransmissionCount',
                        ellipsis: true,
                        sorter: true,
                        "width": 100,
                    }

                ]
            },
            "renderPage": {
                size: "middle",
                pageSizeOptions: ['10', '20', '30', '40']
            }
        },
    ]
};
